import request from "@/utils/request";

// 机构列表
export function getOrganList(params) {
  return request({
    url: "/wechat/service/provider",
    method: "get",
    params
  });
}
// 机构详情
export function getOrganDetail(params) {
  return request({
    url: `/wechat/service/provider/${params}`,
    method: "get"
  });
}
// 南京东路居委
export function getCommittee(params) {
  return request({
    url: "/base/area/tree",
    method: "get",
    params
  });
}

// 获取坐标
export function mapList(areaCode) {
  return request({
    url: "/wechat/screen/map/ready/?areaCode=" + areaCode,
    method: "get"
  });
}

// 政策法规列表
export function getMapList(params) {
  return request({
    url: "/wechat/service/provider/count",
    method: "get",
    params
  });
}

// 社区设施（家）
export function countOrgByAreaCode(params) {
  return request({
    url: "/wechat/screen/map/service/countOrgByAreaCode",
    method: "get",
    params
  });
}
